import { render, staticRenderFns } from "./SideBarComponent.vue?vue&type=template&id=f8ebba36"
import script from "./SideBarComponent.vue?vue&type=script&lang=js"
export * from "./SideBarComponent.vue?vue&type=script&lang=js"
import style0 from "./SideBarComponent.vue?vue&type=style&index=0&id=f8ebba36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports